/* eslint-disable no-unused-vars */
import * as S from './Tab.styled';

export const Tab = ({ label, disabled, pressed, value, onChange, hidden, style, error }) => {
  if (hidden) return null;

  return (
    <S.Container
      error={error}
      style={style}
      pressed={pressed}
      disabled={disabled}
      onClick={() => onChange(value)}
    >
      {label}
    </S.Container>
  );
};
